import React from 'react';
import { ScoringEventDto } from './useScoringEvents';

export const ScoringEventsContext = React.createContext<ScoringEventDto | null>(null);
